<template>
  <div>
    <b-container fluid class="px-5">

      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div class="d-flex align-items-center justify-content-start">
          <back-arrow :title="animal.name"/>
          <b-badge class="mb-1 ml-2" variant="dark" v-if="animal.isDead">Animal décédé</b-badge>
        </div>
        <show-actions
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
        ></show-actions>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">
        <b-row class="mb-2">
          <b-col>
            <div class="bold-text main-color">
              Espèce
            </div>
            <div class="mt-2">
              {{ animal.species.name }}
            </div>
          </b-col>
          <b-col>
            <div class="bold-text main-color">
              Propriétaire
            </div>
            <div class="mt-2">
              <b-link :to="{ name: 'UserShow', params: { userId: animal.user.id }}">
                {{ animal.user.name }}
              </b-link>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-2 mb-2">
          <b-col>
            <div class="bold-text main-color">
              Famille
            </div>
            <div class="mt-2">
              {{ animal.species.family }}
            </div>
          </b-col>
          <b-col>
            <div class="bold-text main-color">
              Hospitalisation
            </div>
            <div class="mt-2" v-if="hospitalizations.length > 0">
              <template v-for="hospitalization in hospitalizations">
                <div v-if="!hospitalization.endDate">
                  <b-link class="font-weight-bold" :to="{ name: 'HospitalizationShow', params: { hospitalizationId: hospitalization.id }}">
                    En cours du {{new Date(hospitalization.startDate).toLocaleDateString("fr-FR")}}
                  </b-link>
                </div>
                <div class="mt-1" v-else>
                  <b-link :to="{ name: 'HospitalizationShow', params: { hospitalizationId: hospitalization.id }}">
                    Terminée du {{new Date(hospitalization.startDate).toLocaleDateString("fr-FR")}} au
                    {{new Date(hospitalization.endDate).toLocaleDateString("fr-FR")}}
                  </b-link>
                </div>
              </template>
            </div>
            <div class="mt-2" v-else>
              Aucune hospitalisation associée
            </div>
          </b-col>
        </b-row>
        <b-row v-if="animal.dateOfBirth != null">
          <b-col>
            <div class="bold-text main-color">
              Date de naissance
            </div>
            <div class="mt-2">
              {{ new Date(animal.dateOfBirth).toLocaleDateString("fr-FR")}}
            </div>
          </b-col>
        </b-row>
      </b-card>

      <AnimalSurvey v-if="animal.surveySpecies !== null" :animalId="animalId"/>

    </b-container>

    <!-- Modal Delete -->
    <animal-delete-modal :selectedAnimal="animal" @didDeleteAnimal="didDeleteAnimal()"></animal-delete-modal>


  </div>
</template>

<script>
    import api from '../../services/api';
    import BackArrow from "../../components/BackArrow";
    import ShowActions from "../../components/ShowActions";
    import AnimalDeleteModal from "./AnimalDeleteModal";
    import AnimalSurvey from "./AnimalSurvey";

    export default {

        name: 'AnimalShow',

        components: {
          AnimalSurvey,
            BackArrow,
            ShowActions,
            AnimalDeleteModal
        },

        data() {
            return {
                animalId: this.$route.params.animalId,
                animal: null,
                hospitalizations: [],

                ui: {
                    selectedAnimal: null
                }
            }
        },

        mounted () {
            this.fetchData()
        },

        methods: {
            fetchData() {
                this.fetchAnimal()
            },
            fetchAnimal() {
                api
                    .get(`/animal/${this.animalId}`)
                    .then(response => {
                        this.animal = response.data
                        this.fetchHospitalizations()
                    })
            },
            fetchHospitalizations(){
                api
                    .get(`/hospitalization?animalId=${this.animal.id}`)
                    .then((response) => {
                        this.hospitalizations = response.data
                        this.hospitalizations.sort((a,b) => (a.startDate < b.startDate) ? 1 : ((b.startDate < a.startDate) ? -1 : 0))
                    })
            },
            clickOnEditBtn() {
                this.$router.push({
                    name: 'AnimalEdit',
                    params: {
                        animalId: this.animal.id
                    }
                })
            },
            clickOnDeleteBtn() {
                this.ui.selectedAnimal = this.animal
                this.$bvModal.show('animal-delete-modal')
            },
            didDeleteAnimal() {
                this.ui.selectedAnimal = null;
                this.$router.push({
                    name: 'AnimalIndex'
                }, () => {
                    this.$nextTick(() => {
                        this.successToast(`Animal \"${this.animal.name}\" supprimé`)
                    })
                })
            },
            successToast(message) {
                this.$bvToast.toast(message, {
                    autoHideDelay: 2000,
                    toaster: 'b-toaster-bottom-right',
                    noCloseButton: true
                })
            }

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/animal/AnimalShow.vue